<template>
    <div class="ChoiceItem --global-clickable" :class="[`state-${state}`]" @click.stop="handleClick">
        <MnemonicImage class="image" :image="image" />
    </div>
</template>

<script>
import { TimelineLite, Power2 } from 'gsap';
import MnemonicImage from '@/components/MnemonicImage';

export default {
    components: { MnemonicImage },
    props: {
        image: {
            type: String
        },
        attempts: {
            type: Array
        }
    },
    data() {
        return {
            state: 'ready'
        };
    },
    watch: {
        attempts(value) {
            let lastAttempt = value[value.length - 1];
            if (lastAttempt.matched) {
                this.onCorrect();
            } else {
                this.onWrong();
            }
        }
    },
    beforeDestroy() {
        if (this.tl) {
            this.tl.kill();
        }
    },
    methods: {
        handleClick() {
            if (this.state === 'ready') {
                this.$emit('click');
            }
        },
        onCorrect() {
            this.state = 'correct';
            this.tl = new TimelineLite({
                onComplete: () => {}
            });
            this.tl.to(this.$el, 0.1, {
                scale: 1.1,
                ease: Power2.easeInOut
            });
            this.tl.to(this.$el, 0.3, {
                scale: 0.7,
                opacity: 0,
                ease: Power2.easeInOut
            });
        },
        onWrong() {
            this.state = 'wrong';
            this.tl = new TimelineLite({
                onComplete: () => {
                    this.state = 'ready';
                }
            });
            this.tl.to(this.$el, 0.1, {
                x: -7,
                ease: Power2.easeInOut
            });
            this.tl.to(this.$el, 0.1, {
                repeat: 4,
                x: 7,
                yoyo: true,
                ease: Power2.easeInOut
            });
            this.tl.to(this.$el, 0.1, {
                x: 0
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.ChoiceItem {
    &:not(.state-ready) {
        cursor: default;
    }
}
.image {
    border-radius: 4px;
}
</style>
